// extracted by mini-css-extract-plugin
export default {"footer":"_2rTiFXm6-tEAu0pn_2L1Ux"};